// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1CompanySchema = z.object({
  id: z.number().int().describe("Unique identifier for the client"),
  name: z.coerce.string().describe("Name of the client"),
  active: z.boolean().describe("Whether the client is active"),
  external_id: z.nullable(z.coerce.string().describe("External ID for the client")),
  updated_at: z.string().datetime().describe("iso8601"),
  color: z.coerce.string().describe("Client display color (hex code)"),
  external_references: z.optional(z.array(z.object({
    id: z.number().int(),
    provider_type: z.coerce.string(),
    provider_id: z.coerce.string(),
    updated_at: z.string().datetime(),
    connection_id: z.number().int(),
    url: z.coerce.string().url(),
  })).describe("External references for the client")),
  tic: z.optional(z.object({
    uri: z.coerce.string().describe("Canonical TIC identifier (e.g., tic://jira/workspace-id/clients/abc123). Immutable once set."),
    tool_id: z.coerce.string().describe("Original external tool identifier (e.g., jira, trello, asana).").nullish(),
    external_url: z.coerce.string().describe("Direct link to the client in the external tool.").nullish(),
  }).describe("Integration metadata (internal only). Present for synced clients.")),
});
